import { render, staticRenderFns } from "./MailFilters.vue?vue&type=template&id=6c57d5b9&scoped=true"
import script from "./MailFilters.vue?vue&type=script&lang=js"
export * from "./MailFilters.vue?vue&type=script&lang=js"
import style0 from "./MailFilters.vue?vue&type=style&index=0&id=6c57d5b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57d5b9",
  null
  
)

export default component.exports